import { createGenerateClassName } from '@material-ui/core/styles';

const generateClassName = createGenerateClassName({
  productionPrefix: 'myApp-', // Prefix to avoid conflicts
  disableGlobal: true, // Disable global class names
});

export default generateClassName;
